<template>
    <vs-card>
        <div class="border_btm py-2">
            <h4>Class Description</h4>
            <vs-row class="my-6">
                <vs-col vs-lg="5" vs-sm="12">
                    <div class="image_preview_holder">
                        <div
                        class="flex flex-col justify-center items-center w-full h-full"
                        v-if="!preview"
                        >
                        <svg
                            width="62"
                            height="62"
                            viewBox="0 0 62 62"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M49.9229 19.7628V14.2086H44.3687V10.3336H49.9229V4.71484H53.7979V10.3336H59.4167V14.2086H53.7979V19.7628H49.9229ZM6.07083 56.8336C5.0375 56.8336 4.13333 56.4461 3.35833 55.6711C2.58333 54.8961 2.19583 53.9919 2.19583 52.9586V19.8273C2.19583 18.8371 2.58333 17.9437 3.35833 17.1471C4.13333 16.3506 5.0375 15.9523 6.07083 15.9523H15.5646L20.2792 10.3336H38.3625V14.2086H22.0875L17.3729 19.8273H6.07083V52.9586H49.9875V25.8336H53.8625V52.9586C53.8625 53.9919 53.4642 54.8961 52.6677 55.6711C51.8712 56.4461 50.9778 56.8336 49.9875 56.8336H6.07083ZM28.0292 47.4044C31.1292 47.4044 33.734 46.3496 35.8437 44.2398C37.9535 42.1301 39.0083 39.5037 39.0083 36.3607C39.0083 33.2607 37.9535 30.6666 35.8437 28.5784C33.734 26.4902 31.1292 25.4461 28.0292 25.4461C24.8861 25.4461 22.2705 26.4902 20.1823 28.5784C18.0941 30.6666 17.05 33.2607 17.05 36.3607C17.05 39.5037 18.0941 42.1301 20.1823 44.2398C22.2705 46.3496 24.8861 47.4044 28.0292 47.4044ZM28.0292 43.5294C25.9625 43.5294 24.2618 42.8513 22.9271 41.4951C21.5924 40.1388 20.925 38.4273 20.925 36.3607C20.925 34.3371 21.5924 32.6579 22.9271 31.3232C24.2618 29.9885 25.9625 29.3211 28.0292 29.3211C30.0528 29.3211 31.7427 29.9885 33.099 31.3232C34.4552 32.6579 35.1333 34.3371 35.1333 36.3607C35.1333 38.4273 34.4552 40.1388 33.099 41.4951C31.7427 42.8513 30.0528 43.5294 28.0292 43.5294Z"
                            fill="#808080"
                            />
                        </svg>
                        <h4 style="color: #808080" class="my-2">Add class image</h4>
                        </div>
                        <input
                        type="file"
                        accept="image/*"
                        />
                        <template v-if="preview">
                        <img :src="preview" class="image" />
                        </template>
                    </div>

                    <div class="py-4">
                        <!-- <div class="pb-3" v-if="preview_video">
                        {{ video.name }}
                        </div> -->
                        <div class="button_file_holder">
                        <input
                            type="file"
                            accept="video/mp4,video/x-m4v,video/*"
                        />
                        <vs-button icon="upload">Upload Class Preview Video</vs-button>
                        </div>
                    </div>
                </vs-col>
                <vs-col vs-lg="7" vs-sm="12" class="sm:pl-4 pl-0">
                    <vs-row>
                        <vs-col vs-lg="7" vs-sm="12" class="p-2">
                            <label class="vs-input--label">Class Name</label>
                            <vs-input type="text" class="w-full" placeholder="Class Name" />
                        </vs-col>
                        <vs-col vs-lg="5" vs-sm="12" class="p-2">
                            <label class="vs-input--label">Class Capacity</label>
                            <vs-input type="number" class="w-full" placeholder="Class Capacity" />
                        </vs-col>
                        <vs-col vs-lg="7" vs-sm="12" class="p-2">
                            <label class="vs-input--label">Term</label>
                            <v-select class="w-full" placeholder="Select Term" />
                        </vs-col>
                        <vs-col vs-lg="5" vs-sm="12" class="p-2">
                            <label class="vs-input--label">Room</label>
                            <v-select class="w-full" placeholder="Select Room" />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-2">
                            <label class="vs-input--label">Start Date</label>
                            <div class="flatpickr_with_icon">
                                <flat-pickr
                                    class="w-full"
                                    placeholder="Start Date"
                                />
                                <vs-icon icon-pack="feather" icon="icon-calendar" />
                            </div>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-2">
                            <label class="vs-input--label">End Date</label>
                            <div class="flatpickr_with_icon">
                                <flat-pickr
                                    class="w-full"
                                    placeholder="End Date"
                                />
                                <vs-icon icon-pack="feather" icon="icon-calendar" />
                            </div>
                        </vs-col>
                        <vs-col vs-w="12" class="p-2">
                            <label class="vs-input--label">Description</label>
                            <vs-textarea class="w-full" placeholder="Enter title" />
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>
        </div>

        <div class="border_btm py-2">
            <h4 class="mt-4">Holiday(s)</h4>
            <vs-row class="mb-6">
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <label class="vs-input--label">Select Holidays</label>
                    <v-select multiple class="w-full" />
                </vs-col>
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <label class="vs-input--label block">School Holidays</label>
                    <div class="cstm_badge">Holiday</div>
                </vs-col>
            </vs-row>
        </div>

        <div class="border_btm py-2">
            <h4 class="mb-4">Classroom</h4>
            <vs-row class="mb-6">
                <vs-col vs-lg="6" vs-sm="12" class="p-2">
                    <label class="vs-input--label">Class Teacher</label>
                    <v-select multiple class="w-full" />
                </vs-col>
                <vs-col vs-w="12" class="p-2">
                    <label class="vs-input--label">Teachers</label>
                    <v-select multiple class="w-full" placeholder="Assign Teachers" />
                </vs-col>
                <vs-col vs-w="12" class="p-2">
                    <label class="vs-input--label">Students</label>
                    <v-select multiple class="w-full" placeholder="Add Students" />
                    <div class="text-right">
                        <a class="primary">Upload CSV</a>
                    </div>
                </vs-col>
            </vs-row>
        </div>

        <vs-button class="block mx-auto mt-6">Save</vs-button>
    </vs-card>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'class-create',
  data () {
    return {
            
    }
  },
  components: {
    vSelect,
    flatPickr
  }
}
</script>